export default {
  GET_CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_QUERY: Symbol.for('GET_CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_QUERY'),
  CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_REPOSITORY: Symbol.for('CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_REPOSITORY'),
  CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_STATE_MANAGER: Symbol.for('CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_STATE_MANAGER'),
};
